import { FC } from 'react';
import { StatusUpdateForm } from 'react-activity-feed';

import styles from './Post.module.css';

export type Props = {
  onSendMessage: () => void;
};

export const Post: FC<Props> = ({ onSendMessage, ...props }) => {
  return (
    <StatusUpdateForm
      {...props}
      className={styles.form}
      activityVerb="tweet"
      Header={null}
      FooterItem={null}
      modifyActivityData={({ actor, text, verb }) => {
        return {
          actor,
          tweet: text,
          verb,
          object: 1,
        };
      }}
      onSuccess={onSendMessage}
    />
  );
};
